import { SHInputAdornment, SHStack } from "@components/design-systems";
import { SHNumericFieldV2 } from "@components/design-systems/sh-numeric-field-v2";
import { Dollar2SVG } from "@components/svgs";
import { useFeeCalculatorAutoCalculatedField } from "@hooks/useFeeCalculatorAutoCalculatedField";
import { FeeCalculatorRenderFieldProps } from "@models/platform-analysis/entities/steps/fee";
import { useTheme } from "@mui/material";
import { memo } from "react";
import { AnalysisFeeCalculatorStepConfigs } from "../../../configs";

export const AutoCalculatedInput = memo(
  ({ fieldConfig }: FeeCalculatorRenderFieldProps) => {
    const { palette } = useTheme();
    const { calculatedValue } = useFeeCalculatorAutoCalculatedField(
      fieldConfig.autoCalculateConfig,
    );

    const showDecimalScale = Math.abs(calculatedValue ?? 0) % 1 !== 0;
    const decimalScale = showDecimalScale
      ? AnalysisFeeCalculatorStepConfigs.DefaultDecimalPlaces
      : 0;

    return (
      <SHStack width={"100%"} height={"100%"}>
        <SHNumericFieldV2
          disabled
          fullWidth
          thousandSeparator
          valueIsNumericString
          fixedDecimalScale={showDecimalScale}
          decimalScale={decimalScale}
          value={String(calculatedValue)}
          label={fieldConfig.name}
          InputProps={{
            startAdornment: (
              <SHInputAdornment position="start">
                <Dollar2SVG />
              </SHInputAdornment>
            ),
          }}
          sx={{
            "& .MuiInput-root": {
              "&::before,&::after": {
                left: "30px",
              },
            },
            ...(calculatedValue < 0 && {
              "& .MuiInputBase-input.Mui-disabled": {
                WebkitTextFillColor: palette.warning.main,
              },
              "& .MuiInput-underline.Mui-disabled:before": {
                borderBottomColor: palette.warning.main,
                borderBottomStyle: "solid",
              },
            }),
          }}
        />
      </SHStack>
    );
  },
);
